import { render, staticRenderFns } from "./ModalSendSign.vue?vue&type=template&id=6d677e18&scoped=true"
import script from "./ModalSendSign.vue?vue&type=script&lang=js"
export * from "./ModalSendSign.vue?vue&type=script&lang=js"
import style0 from "./ModalSendSign.vue?vue&type=style&index=0&id=6d677e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d677e18",
  null
  
)

export default component.exports